<template>
  <div class="dark-overlay" @click.self="closeModal">
    <div class="pop-up2">
      <h4>Estimación de horas</h4>
      <div class="form-group">
        <label for="newDate">Posición del empleado:</label>
        <select
          class="form-control"
          v-model="band.estimated_work_hour.employee_position"
        >
          <option
            v-for="opt in employeesPositions"
            :key="opt.id"
            :value="opt.id"
            style="color: black"
          >
            {{ opt.name }}
          </option>
        </select>
      </div>

      <div class="form-group mt-2">
        <label>Tiempo de trabajo estimado:</label>
        <input
          class="form-control"
          type="text"
          v-model="band.estimated_work_hour.estimated_hours"
        />
      </div>
      <br />
      <div class="button-container">
        <button @click="closeModal" class="btn btn-outline-danger btn-long">
          Cerrar
        </button>
        <button
          class="btn btn-outline-light btn-long"
          @click="saveEstimatedWorkHours"
        >
          Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  onMounted,
  onBeforeUnmount,
  defineProps,
  defineEmits,
  reactive,
} from "vue";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";

const props = defineProps({
  idProject: {
    type: [Number, String],
    required: false,
  },
});

const emit = defineEmits(["close"]);
const store = useStore();
const employeesPositions = ref([]);

const band = reactive({
  estimated_work_hour: {
    estimated_hours: null,
    project_id: props.idProject,
    employee_position: "",
  },
  employee_position_list: employeesPositions,
  title: "Estimación de horas",
});

const handleKeyup = (e) => {
  if (e.key === "Escape") closeModal();
};

const closeModal = () => {
  band.estimated_work_hour.employee_position = "";
  band.estimated_work_hour.estimated_hours = null;
  emit("close");
};

const saveEstimatedWorkHours = async () => {
  band.estimated_work_hour.project_id =
    band.estimated_work_hour.project_id.toString();
  band.estimated_work_hour.estimated_hours = Number(
    band.estimated_work_hour.estimated_hours
  );
  try {
    const res = await store.dispatch("saveEstimatedWorkHours", band);
    if (res) toast.success(res.notice, { autoClose: 4000, theme: "dark" });
    closeModal();
  } finally {
    //
  }
};

watch(
  () => props.idProject,
  (val) => {
    if (val != null) band.estimated_work_hour.project_id = val;
  },
  { immediate: true }
);

onMounted(async () => {
  window.addEventListener("keyup", handleKeyup);
  try {
    const res = await store.dispatch("fetchEmployeePositions");
    employeesPositions.value = res;
  } catch {
    //
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("keyup", handleKeyup);
});
</script>

<style>
.dark-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(41, 41, 41, 0.5);
  z-index: 1;
  overflow: auto;
}
.pop-up2 {
  padding: 30px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background-color: #141218;
  border-radius: 20px;
  border: 1px solid #f4641652;
  overflow: auto;
  min-width: 40vw;
  min-height: 40vh;
  max-width: 60vw;
  max-height: 70vh;
  box-sizing: border-box;
}

.button-container {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn-long {
  width: 100px;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 200ms ease-in-out;
}
</style>
